// styles imports
import './LoadingBox.scss';

export default function LoadingBox(props) {
  return (
    <div 
      className={"loading-box " + (props.className ? props.className : "")} 
      >
      <div className="half-circle-spinner">
        <div className="circle circle-1"></div>
        <div className="circle circle-2"></div>
      </div>
    </div>
  );
}
